import { render } from "./chart-c3.vue?vue&type=template&id=227b719a"
import script from "./chart-c3.vue?vue&type=script&lang=js"
export * from "./chart-c3.vue?vue&type=script&lang=js"

import exportComponent from "C:\\GigLabs\\CIMS\\CIMS-AfyunProd\\gig.ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__